import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReadingAstrology = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "constellation 1",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M16 18.6667C17.4728 18.6667 18.6667 17.4728 18.6667 16C18.6667 14.5272 17.4728 13.3333 16 13.3333C14.5272 13.3333 13.3333 14.5272 13.3333 16C13.3333 17.4728 14.5272 18.6667 16 18.6667Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M26.6667 24C28.1395 24 29.3333 22.8061 29.3333 21.3333C29.3333 19.8605 28.1395 18.6667 26.6667 18.6667C25.1939 18.6667 24 19.8605 24 21.3333C24 22.8061 25.1939 24 26.6667 24Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M14.6667 29.3333C16.1395 29.3333 17.3333 28.1395 17.3333 26.6667C17.3333 25.1939 16.1395 24 14.6667 24C13.1939 24 12 25.1939 12 26.6667C12 28.1395 13.1939 29.3333 14.6667 29.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M20 8C21.4728 8 22.6667 6.80609 22.6667 5.33333C22.6667 3.86057 21.4728 2.66667 20 2.66667C18.5272 2.66667 17.3333 3.86057 17.3333 5.33333C17.3333 6.80609 18.5272 8 20 8Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M5.33333 13.3333C6.80609 13.3333 8 12.1394 8 10.6667C8 9.19391 6.80609 8 5.33333 8C3.86057 8 2.66667 9.19391 2.66667 10.6667C2.66667 12.1394 3.86057 13.3333 5.33333 13.3333Z",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M19.3333 8L16.6667 13.3333M17.3333 6L8 10M16 18.6667L14.6667 24M18.6667 17.3333L24 20M24 22.6667L17.3333 26",
				stroke: "var(--stroke-0, #9565FD)",
				strokeWidth: 2,
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgReadingAstrology;
